import { createPopper } from "@popperjs/core";

export default {
    emits: ["popper-closed", "popper-opened"],
    data() {
        return {
            // Placement can be overwritten in the inherited component
            popper_popperPlacement: "right-start",
            // Modifiers can be overwritten in the inherited component
            popper_modifiers: [],
            popper_useHideOnOutsideClick: true,
            // Wrap the parent component in a `v-if/v-show="popper_isVisible"`
            popper_isVisible: false,
            popper_object: null,
            popper_referenceObject: null
        };
    },
    unmounted() {
        this.popper_hide();
    },
    methods: {
        popper_hideOnOutsideClick($event) {
            if (
                $event.target !== this.popper_referenceObject &&
                !this.popper_referenceObject.contains($event.target) &&
                $event.target !== this.$el &&
                !this.$el.contains($event.target)
            ) {
                this.popper_hide();
            }
        },
        popper_toggle(reference) {
            if (this.popper_isVisible) {
                this.popper_hide();
            } else {
                this.popper_show(reference);
            }
        },
        popper_hide() {
            if (!this.popper_object) {
                return;
            }

            this.popper_object.destroy();
            this.popper_object = null;
            this.popper_referenceObject = null;
            this.popper_isVisible = false;
            document.removeEventListener("click", this.popper_hideOnOutsideClick, true);
            this.$emit("popper-closed");
        },
        async popper_show(reference) {
            if (this.popper_object) {
                return;
            }

            this.popper_isVisible = true;
            this.popper_referenceObject = reference;

            // Wait for the root dom element to exist before creating the popper
            if (!(this.$el instanceof HTMLElement)) {
                await this.$nextTick();
            }

            const modifiers =
                this.custom_modifiers == null
                    ? [
                          {
                              name: "preventOverflow",
                              enabled: true,
                              options: {
                                  padding: 0
                              }
                          },
                          ...this.popper_modifiers
                      ]
                    : [
                          {
                              name: "preventOverflow",
                              enabled: true,
                              options: {
                                  padding: 0
                              }
                          },
                          ...this.popper_modifiers,
                          ...this.custom_modifiers
                      ];

            this.popper_object = createPopper(reference, this.$el, {
                placement: this.popper_popperPlacement,
                modifiers
            });

            if (this.popper_useHideOnOutsideClick) {
                document.addEventListener("click", this.popper_hideOnOutsideClick, true);
            }
            if (this.popper_onShow) {
                this.popper_onShow();
            }
            this.$emit("popper-opened");
        }
    }
};
